import { common } from '@/common/service/ApiList';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
import ServiceExec from '@/common/utils/ServiceExec';
import store from '@/store';

const SPLASH_INTRO_LOG_TIMEOUT = 2500;

const toNumber = (value = 0) => Number(value ?? 0);
const sanitizeError = (error = {}) => ({
  name: error?.name ?? '',
  message: error?.message ?? '',
  code: error?.code ?? '',
  status: error?.response?.status ?? ''
});

const createBasePayload = () => {
  const userData = store.getters['user/getUserData'] ?? {};
  const deviceInfo = store.getters['user/getDeviceInfo'] ?? {};
  const position = store.getters['user/getUserPosition'] ?? {};
  const latitude = toNumber(position.latitude);
  const longitude = toNumber(position.longitude);

  return {
    userNo: toNumber(userData.userNo),
    deviceType: deviceInfo.deviceType ?? '',
    appVersion: deviceInfo.appVersion ?? '',
    os: deviceInfo.os ?? '',
    path: window.location?.pathname ?? '',
    query: window.location?.search ?? '',
    userAgent: navigator.userAgent ?? '',
    isApp: (navigator.userAgent ?? '').includes(CODE_ENV_LIST.APP_SCHEMA),
    positionValid: latitude !== 0 && longitude !== 0,
    occurredAt: new Date().toISOString()
  };
};

export const logSplashIntroIssue = (reason = '', context = {}) => {
  if (!reason) return;

  const payload = {
    type: 'SPLASH_INTRO',
    reason,
    ...createBasePayload(),
    context
  };

  void ServiceExec.post(common.splashIntroLog, payload, {
    notLoading: true,
    timeout: SPLASH_INTRO_LOG_TIMEOUT
  }).catch(() => null);
};

export const logSplashIntroError = (reason = '', error = {}, context = {}) => {
  logSplashIntroIssue(reason, {
    ...context,
    error: sanitizeError(error)
  });
};
